import pubSub from './pubSub';

const appBus = pubSub();

export default appBus;
